<template>
  <div class="container">
    <el-card header="Pokrzyk-Plaid">
      <div id="auth-card">
        <div>Use your google account to sign in.</div>
        <a class="button" @click.stop.prevent="onClick" href="http://google.com">
          <div class="button_logo"></div>
          <div class="button_text">Sign in with Google</div>
        </a>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'auth',
  props: ['onClick']
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.card-header {
  background-color: green;
}

#auth-card {
  min-height: 150px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  padding: 0 40px;
}

.button {
  align-items: center;
  display: flex;
  background: #1685CD;
  border: 1px solid #1685CD;
  text-decoration: none;
  width: 238px;
}

.button:hover {
  opacity: 1;
  background: #1685CD;
  border-color: #1685CD;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.25), inset 0px 1px 2px 0px transparent;
}

.button:active {
  background: #147ABD;
  border-color: #147ABD;
  box-shadow: none;
}

.button_logo {
  background: url(../assets/google_logo.png) #fff 50% 50% no-repeat;
  background-size: 18px;
  background-color: white;
  width: 40px;
  height: 40px;
}

.button_text {
  color: white;
  flex: 1;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// SignIn.vue?8dac80e0